import { createAppRequest } from '@/services/request';

const request = createAppRequest();

export interface OpenPlatformTokenResult {
  accessToken: string;
}

interface OpenPlatformTokenEnvelope<T> {
  code: number;
  msg: string;
  data: T;
}

export async function getOpenPlatformToken() {
  const response = await request<OpenPlatformTokenEnvelope<OpenPlatformTokenResult>>(
    '/bff/open-platform/token',
    {
      method: 'GET',
    },
  );
  return response.data;
}
